import ClientModal from './ClientModal';

export default ClientModal;